import React from 'react';

function withDesignSystemLoader(WrappedComponent) {
  return class extends React.Component {
    dsLoaderDelay;
    entryPointElement;

    constructor(props) {
      super(props);

      this.state = {
        designSystemLoaded: process.env.NODE_ENV === 'test' ? true : false
      }

      this.entryPointElement = document.getElementsByClassName('ds-container');
    }

    componentDidMount() {
      if (process.env.NODE_ENV !== 'test') {
        this.setDsLoaderChecker();
        this.loadDesignSystem();
      }
    }

    loadDesignSystem() {
      const linkElement = document.createElement('link');
      linkElement.setAttribute('rel', 'stylesheet');
      linkElement.setAttribute('type', 'text/css');
      linkElement.setAttribute('crossOrigin', 'anonymous');
      linkElement.setAttribute(
        'href',
        'https://design.firstcircle.io/html/assets/main-dist.css'
      );
      document.head.appendChild(linkElement);
    }

    setDsLoaderChecker() {
      this.dsLoaderDelay = setInterval(() => {
        if (this.entryPointElement && this.entryPointElement.length > 0) {
          const elementStyle = getComputedStyle(this.entryPointElement[0]);

          // Without DS, the position will be static as the default.
          // After DS gets loaded and ready, position will be relative as set in our DS.
          // This is enough to assume that the app already loaded DS.
          if (elementStyle.position === 'relative' && !this.state.designSystemLoaded) {
            this.setState({ designSystemLoaded: true });
            clearInterval(this.dsLoaderDelay);
          }
        }
      }, 500);
    }

    render() {
      return <WrappedComponent dsLoaded={this.state.designSystemLoaded} />
    }
  }
}

export default withDesignSystemLoader;


// WEBPACK FOOTER //
// ./src/utils/withDesignSystemLoader.js